import type { ReactNode } from 'react';

export const symbol_blinds_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M221-80q-24.75 0-42.37-17.63Q161-115.25 161-140v-516h-51q-12.75 0-21.37-8.63Q80-673.25 80-686v-82q0-46.67 32.67-79.33Q145.33-880 192-880h576q46.67 0 79.33 32.67Q880-814.67 880-768v82q0 12.75-8.62 21.37Q862.75-656 850-656h-50v516q0 24.75-17.62 42.37Q764.75-80 740-80H221Zm0-60h519v-145H221v145Zm0-205h519v-146H633v52q0 12.75-8.62 21.37Q615.75-409 603-409q-12 0-21-8.63-9-8.62-9-21.37v-52H221v146Zm0-206h352v-105H221v105Zm412 0h107v-105H633v105ZM140-716h680v-51.93Q820-790 805.05-805T768-820H192q-22.1 0-37.05 14.95Q140-790.1 140-768v52Zm680 0H140h680Z"
		/>
	</svg>
);
